import { Injectable } from '@angular/core';
import { HttpClient, } from '@angular/common/http';
import { Observable, } from 'rxjs';
import { map, } from 'rxjs/operators';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
import { ErrorService } from 'src/app/error.service';
@Injectable({
    providedIn: 'root'
})
export class ManageService extends Subject<DataStateChangeEventArgs>{
    constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
        super();
    }
    public outputValues(state): void {
        this.getServiceGroupList(state).subscribe(x => super.next(x));
    }
    getServiceGroupList(state): Observable<DataStateChangeEventArgs> {
        let url = "api/ServiceGroup/getGroupServiceMaps";
        return this.http.post<any>(url, state)
            .pipe(map(
                (response: any) =>
                    <any>{
                        result: response['result'],
                        count: response['count']
                    }
            )).pipe(map((e: any) => {
                e.result = this.setdata(e);
                return e;
            })
            )
    }
    setdata(data) {
        let parentArray = [];
        if (data.result.length != 0) {
            data.result.forEach(element => {
                if (element.list.length != 0) {
                    let object =
                    {
                        'serviceGroupName': element.list[0].serviceGroupName,
                        'service': element.list.map(el => { return el.service }),
                        'serviceCode': element.list.map(el => { return el.serviceCode }),
                        'Id': element.list[0].id,
                        'serviceGroupId': element.list[0].serviceGroupId,
                        'masterServiceId': element.list.map(el => { return el.masterServiceId.toString() }),
                        'masterServiceName': element.list.map(el => { return el.masterServiceName }),
                    }
                    parentArray.push(object);

                }
            });
        }
        else {
            parentArray = []
        }
        return parentArray;
    }
}
